var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useContext, useEffect, useRef, useState } from '@max/max';
import View from '@hfe/max-view';
import { withSkeleton } from '@nibfe/marketing-blocks-skeleton';
import './index.scss';
import DoubleCard from './component/doubleCard';
import SingleCard from './component/singleCard';
import MoreBtn from './component/moreBtn';
import { MORE_MC, skData } from './utils/constant';
import { getCommonInfo } from './utils/helper';
import HorizontalCard from './component/horizontalCard';
import ScrollView from '@hfe/max-scrollview';
import LoadingView from '@max/leez-loading-view';
import Text from '@hfe/max-text';
import { loadSupplyData } from '@nibfe/mkt-supply-api';
import Sensor from '@max/mbc-sensor';
const MyComponent = (props) => {
    const { menuId, collapsable, dealText, _LXReport, dealStyle, _raptorReport, useCitySelect, renderSkeleton, closeSkeleton } = props;
    const { showMoreButtonVisible, size, moreSize, showMoreImage } = collapsable;
    const { mvReport, mcReportWithTag } = _LXReport;
    const cityIdSelect = useRef(undefined);
    const [allDeals, setAllDeals] = useState([]); // 所有加载的商品数据
    const [displayCount, setDisplayCount] = useState(size || 4); // 当前显示的商品数量
    const [totalCount, setTotalCount] = useState(0); // 服务端总数量
    const [loading, setLoading] = useState(false);
    const ctx = useContext(global._EngineGlobalContext);
    const { reportLog } = _raptorReport || {};
    // 点击查看更多
    function handleMore() {
        if (loading)
            return;
        setLoading(true);
        mcReportWithTag && mcReportWithTag(MORE_MC, {
            valLab: {}
        });
        // 优先显示本地剩余数据
        if (displayCount < allDeals.length) {
            setDisplayCount(allDeals.length);
            setLoading(false);
            return;
        }
        // 请求新数据
        if (displayCount < totalCount) {
            const nextPage = Math.ceil(allDeals.length / (moreSize || 20)) + 1;
            fetchData(nextPage, moreSize || 20);
            return;
        }
        // 已显示全部数据
        setLoading(false);
    }
    // 获取数据
    function fetchData(pageNo, pageSize) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const commonParam = yield getCommonInfo();
            console.log(commonParam, 'commonParam');
            let result;
            try {
                result = yield loadSupplyData({
                    supplyGroupId: menuId,
                    moduleSource: 1,
                    commonParam: Object.assign(Object.assign({}, commonParam), { cityId: (_a = cityIdSelect === null || cityIdSelect === void 0 ? void 0 : cityIdSelect.current) !== null && _a !== void 0 ? _a : commonParam === null || commonParam === void 0 ? void 0 : commonParam.cityId }),
                    pageNo: pageNo,
                    pageSize: pageSize,
                    flowSource: 2,
                    bizType: 1
                }, {
                    apiEnv: 'prod'
                });
                if (!(result === null || result === void 0 ? void 0 : result.data)) {
                    reportLog === null || reportLog === void 0 ? void 0 : reportLog('maker deal双列组件接口异常', result);
                    setLoading(false);
                    return;
                }
                const { dealInfoList = [], totalDealCount = 0 } = result === null || result === void 0 ? void 0 : result.data;
                if (pageNo === 1) {
                    // 首次加载
                    setAllDeals(dealInfoList);
                    setTotalCount(totalDealCount);
                    setDisplayCount(Math.min(size || 4, dealInfoList.length));
                }
                else {
                    // 加载更多
                    const newAllDeals = [...allDeals, ...dealInfoList];
                    setAllDeals(newAllDeals);
                    setDisplayCount(newAllDeals.length);
                }
                setLoading(false);
            }
            catch (err) {
                console.log(err, 'err info');
                (_c = (_b = ctx._uiInteractionAPI) === null || _b === void 0 ? void 0 : _b.toast) === null || _c === void 0 ? void 0 : _c.show({
                    content: (err === null || err === void 0 ? void 0 : err.message) || '活动太火爆啦～'
                });
                setLoading(false);
            }
            closeSkeleton();
        });
    }
    // 重置数据
    function resetData() {
        setAllDeals([]);
        setDisplayCount(size || 4);
        setTotalCount(0);
        setLoading(false);
    }
    useEffect(() => {
        var _a;
        console.log('refresh fetch');
        if (!useCitySelect) {
            return;
        }
        renderSkeleton();
        resetData();
        fetchData(1, moreSize || 20);
        (_a = ctx._communication) === null || _a === void 0 ? void 0 : _a.on('cityChanged', (city) => {
            console.log('双列供给组件-监听到了城市变化', city);
            if (city === null || city === void 0 ? void 0 : city.value) {
                console.log(city === null || city === void 0 ? void 0 : city.value, 'city id change');
                cityIdSelect.current = Number(city.value);
                renderSkeleton();
                resetData();
                fetchData(1, moreSize || 20);
            }
        });
    }, [useCitySelect]);
    useEffect(() => {
        console.log('refresh fetch');
        if (!useCitySelect) {
            renderSkeleton();
            resetData();
            fetchData(1, moreSize || 20);
        }
    }, [useCitySelect]);
    // 当前要显示的商品列表
    const displayDeals = allDeals.slice(0, displayCount);
    // 是否显示更多按钮/内容：当前显示数量小于总数量，且有商品数据
    const showMoreBtn = displayCount < totalCount && displayDeals.length > 0;
    return <View>
      {dealStyle === 'double' && <View className="deal-double">
          {!!(displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.length) && <View className="deal-double-card">
              {displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.map((item, index) => {
                    return <DoubleCard dealText={dealText} _LXReport={_LXReport} index={index} menuId={menuId} item={item} key={index}/>;
                })}
            </View>}

          {showMoreBtn && <View onClick={() => showMoreButtonVisible && handleMore()}>
              <Sensor isInNativeView onAppear={() => {
                    !showMoreButtonVisible && handleMore();
                }}>
                <MoreBtn showMoreImage={showMoreImage} mvReport={mvReport}/>
              </Sensor>
            </View>}
        </View>}

      {dealStyle === 'single' && <View className="deal-single">
          {!!(displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.length) && <View className="deal-single-card">
              {displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.map((item, index) => {
                    return <SingleCard dealText={dealText} _LXReport={_LXReport} index={index} menuId={menuId} item={item} key={index}/>;
                })}
            </View>}

          {showMoreBtn && <View onClick={() => showMoreButtonVisible && handleMore()}>
              <Sensor isInNativeView onAppear={() => {
                    !showMoreButtonVisible && handleMore();
                }}>
                <MoreBtn showMoreImage={showMoreImage} mvReport={mvReport}/>
              </Sensor>
            </View>}
        </View>}

      {dealStyle === 'horizontal' && <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} onEndReachedThreshold={200} onEndReached={() => {
                handleMore();
            }} className="deal-horizontal">
          {!!(displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.length) && (displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.map((item, index) => {
                return <HorizontalCard dealText={dealText} _LXReport={_LXReport} index={index} menuId={menuId} item={item} key={index}/>;
            }))}
          <LoadingView level={'medium'} content={'正在加载更多'} style={!loading && {
                display: 'none'
            }}/>
          <View style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: '18rpx'
            }}>
            <Text style={{
                color: '#999',
                display: showMoreBtn ? 'none' : 'flex'
            }}>{'没有更多了～'}</Text>
          </View>
        </ScrollView>}
    </View>;
};
export default withSkeleton(memo(MyComponent), 750, 1200, skData, false);
// export default memo(MyComponent);
